<template>
  <!-- 数字键盘 [[ -->
  <!-- 交互说明：为fit-key-board 追加fit-key-board-show以显示-->
  <div class="fit-key-board fit-container" :class="{'fit-key-board-show':!hidden}">
    <ul class="keyboard-cell">
      <li class="keyboard-key" data-value="1" @click="bindtap('1')">1</li>
      <li class="keyboard-key" data-value="2" @click="bindtap('2')">2</li>
      <li class="keyboard-key" data-value="3" @click="bindtap('3')">3</li>
    </ul>
    <ul class="keyboard-cell">
      <li class="keyboard-key" data-value="4" @click="bindtap('4')">4</li>
      <li class="keyboard-key" data-value="5" @click="bindtap('5')">5</li>
      <li class="keyboard-key" data-value="6" @click="bindtap('6')">6</li>
    </ul>
    <ul class="keyboard-cell">
      <li class="keyboard-key" data-value="7" @click="bindtap('7')">7</li>
      <li class="keyboard-key" data-value="8" @click="bindtap('8')">8</li>
      <li class="keyboard-key" data-value="9" @click="bindtap('9')">9</li>
    </ul>
    <ul class="keyboard-cell">
      <li class="keyboard-key" data-value="X" v-if="type === 'idcard'" @click="bindtap('X')">X</li>
      <li class="keyboard-key" data-value="." v-else-if="type === 'digit'" @click="bindtap('.')">.</li>
      <li class="keyboard-key keyboard-disabled" data-value v-else>&nbsp;</li>
      <li class="keyboard-key" data-value="0" @click="bindtap('0')">0</li>
      <li
        class="keyboard-key keyboard-ctrl keyboard-clear"
        data-value="DEL"
        @click="bindtap('DEL')"
      >
        <!-- 清除按键 -->
      </li>
    </ul>
  </div>
  <!-- ]] -->
</template>

<script>
/**
 * @module key-board
 * @desc   键盘组件
 * @author peggywang
 *
 * @param {String} [type="number"] :键盘类型，number-数字键盘，idcard-身份证键盘，digit-带小数点的数字键盘
 * @param {Boolean} [hidden=false] ：键盘是否隐藏，默认为false
 */

/**
   * 键盘对外通信的事件
   * 手指触摸后[只有触摸到有效按键才会触发]
   * @event bind-tap
   * @param {object} event 事件对象
   * --------------------------------------
   * event = {
        e:e,            //事件原始对象
        detail:{
            value:8     //0-9,DEL-删除，.-小数点，X身份证X
        }
    }
   * --------------------------------------
   **/

/**
   * @useage
   * --------------------------------------
   *  <fit-key-board :type="type" :hidden="hidden" @bind-tap="onBindTap"></fit-key-board>
   *
   *  var vmInstance = new Vue({
        el: '#example',
        data: function() {
            return {
                type: "number",
                hidden: false
            };
        },
        methods: {
            onBindTap: function(e) {
                console.log(e.detail.value);
            }
        }
    });
   * ---------------------------------------
   **/

import mixins from "@/fit-ui/common/mixin.ts";

/**
 * 为了解决click 的300ms延时问题，需要在页面上加入
 * <head>
 *      <meta name="viewport" content="width=device-width">
 * </head>
 * <style>
 *  html {
 *      touch-action: manipulation;
 *  }
 * </style>
 */

export default {
  name: "fit-keyboard",
  mixins,
  props: {
    type: {
      type: String,
      default: "number"
    },
    hidden: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    bindtap: function(val) {
      if (undefined !== val && val !== "") {
        this.$emit("bind-tap", {
          detail: { value: val }
        });
      }
    }
  }
};
</script>
